import React from 'react';
import { AuthProvider, useAuth } from './context/AuthContext';
import { ToastProvider } from './context/ToastContext';
import { NotificationsProvider } from './context/NotificationsContext';
import { ProjectProvider } from './context/ProjectContext';
import { MarketingLayout } from './layouts/MarketingLayout';
import { StudioLayout } from './layouts/StudioLayout';
import { SpotifyCallback } from './pages/SpotifyCallback';

const AppContent: React.FC = () => {
  const { user, isLoading } = useAuth();

  // Handle Spotify OAuth callback
  if (window.location.pathname === '/spotify-callback') {
    return <SpotifyCallback />;
  }

  if (isLoading) {
    return (
      <div className="min-h-screen bg-zinc-900 flex items-center justify-center">
        <div className="w-8 h-8 rounded-full border-2 border-white/20 border-t-white animate-spin" />
      </div>
    );
  }

  // ROUTING LOGIC: If no user, show Public Landing Page (Marketing Site)
  if (!user) {
    return <MarketingLayout />;
  }

  // If User is logged in, show Studio Layout (App Interface)
  return <StudioLayout />;
};

export default function App() {
  return (
    <ToastProvider>
      <AuthProvider>
        <ProjectProvider>
          <NotificationsProvider>
            <AppContent />
          </NotificationsProvider>
        </ProjectProvider>
      </AuthProvider>
    </ToastProvider>
  );
}
